export default __webpack_public_path__ + "static/media/VERRERIE ET CONSOMMABLE DE LABO.a0e14c34.jpg";